import { find } from "lodash";
import { getMonthListBetweenTwoDates } from "./dateManager";

export const createPoChartData = (barChartData, fromDate, toDate) => {
 
  if (barChartData) {
    var totalPODataset = [];
    var totalPartialPo = [];
    var totalFullyReceived = [];
    var graphlabels = getMonthListBetweenTwoDates(fromDate, toDate);
   
    for (const label of graphlabels) {
      if (
        find(barChartData, { Mth: label.split("-")[0], Y: label.split("-")[1] })
      ) {
        const data = find(barChartData, {
          Mth: label.split("-")[0],
          Y: label.split("-")[1],
        });
       
        totalPODataset.push(data["POCount"]);
        totalPartialPo.push(data["PARTIALLY RECEIVED"]);
        totalFullyReceived.push(data["FULLY RECEIVED"]);
      } else {
        totalPODataset.push(0);
        totalPartialPo.push(0);
        totalFullyReceived.push(0);
      }
    }
    return {
      labels: graphlabels,
      datasets: [
        {
          label: "TOTAL PO",
          data: totalPODataset,
          borderColor: "rgb(255, 99, 132)",
          backgroundColor: "rgba(255, 99, 132, 0.5)",
          tension: 0.5,
        },
        {
          label: "PARTIAL PO",
          data: totalPartialPo,
          borderColor: "rgb(135,186,230)",
          backgroundColor: "rgba(135,186,230, 0.5)",
          tension: 0.5,
        },
        {
          label: "COMPLETED",
          data: totalFullyReceived,
          borderColor: "rgb(187,173,236)",
          backgroundColor: "rgba(187,173,236, 0.5)",
          tension: 0.5,
        },
      ],
    };
  } else {
    return {
      labels: [],
      datasets: [],
    };
  }
};

export const createGRNChartData = (barChartData, fromDate, toDate) => {
  if (barChartData) {
    var totalQcPending = [];
    var totalQcDone = [];
    var graphlabels = getMonthListBetweenTwoDates(fromDate, toDate);
    for (const label of graphlabels) {
      if (
        find(barChartData, { Mth: label.split("-")[0], Y: label.split("-")[1] })
      ) {
        const data = find(barChartData, {
          Mth: label.split("-")[0],
          Y: label.split("-")[1],
        });
        totalQcPending.push(data["QC PENDING"] || 0);
        totalQcDone.push(data["QC DONE"] || 0);
      } else {
        totalQcPending.push(0);
        totalQcDone.push(0);
      }
    }
    return {
      labels: graphlabels,
      datasets: [
        {
          label: "QC PENDING",
          data: totalQcPending,
          borderColor: "rgb(21,136,233)",
          backgroundColor: "rgba(21,136,233, 0.5)",
          tension: 0.5,
        },
        {
          label: "QC DONE",
          data: totalQcDone,
          borderColor: "rgb(124,192,166)",
          backgroundColor: "rgba(124,192,166,0.5)",
          tension: 0.5,
        },
      ],
    };
  } else {
    return {
      labels: [],
      datasets: [],
    };
  }
};

export const createUploadInvoiceChartData = (
  barChartData,
  fromDate,
  toDate
) => {
  if (barChartData) {
    var totalInvoiceUploaded = [];
    var graphlabels = getMonthListBetweenTwoDates(fromDate, toDate);
    for (const label of graphlabels) {
      if (
        find(barChartData, { Mth: label.split("-")[0], Y: label.split("-")[1] })
      ) {
        const data = find(barChartData, {
          Mth: label.split("-")[0],
          Y: label.split("-")[1],
        });
        totalInvoiceUploaded.push(data["Uploaded Invoices"] || 0);
      } else {
        totalInvoiceUploaded.push(0);
      }
    }
    return {
      labels: graphlabels,
      datasets: [
        {
          label: "Invoices",
          data: totalInvoiceUploaded,
          borderColor: "rgb(21,136,233)",
          backgroundColor: "rgba(21,136,233, 0.5)",
          tension: 0.5,
        },
      ],
    };
  } else {
    return {
      labels: [],
      datasets: [],
    };
  }
};
